import { Color } from 'state/color'

MK.events.on('color:aliases:initialize', (event = {}) => {
  Object.values(Color.by.alias).forEach(color => {
    color.attributes.forEach(id => {
      Color.by.attribute[id] = Color.by.attribute[id] || {}
      Color.by.attribute[id][color.alias] = Color.by.attribute[id][color.alias] || Color.by.alias[color.alias]
    })
  })
})
